import React from "react";
import PropTypes from "prop-types";
import { LabelTooltip } from "../../LabelTooltip";
import { Image } from "@learningblocks/shared-components";
import { TrashIcon } from "@learningblocks/storybook-components/lib/Icons";

/**
 * Trash:
 *  - Box of removed tips that attached to micropipette
 */
export function Trash(props) {
  const [show, setShow] = React.useState(false);

  const toggleShow = (value) => () => setShow(value);

  const getLabelStyle = () => {
    return {
      position: "absolute",
      top: "-45px",
      left: "40px",
      whiteSpace: "nowrap",
    };
  };

  const renderTooltip = () =>
    show && <LabelTooltip labelStyle={getLabelStyle()} label={props.label} />;

  return (
    <div onMouseEnter={toggleShow(true)} onMouseLeave={toggleShow(false)}>
      {renderTooltip()}
      <Image src={TrashIcon} alt="trash can" />
    </div>
  );
}

Trash.propTypes = {
  /**
   * Label to display on Trash
   */
  label: PropTypes.string,
};

Trash.defaultProps = {
  label: "Trash Box",
};
